// extracted by mini-css-extract-plugin
module.exports = {"label":"n_bK","text":"n_bL"};